module.exports = __webpack_public_path__ + "static/media/IMG_6519-min.1bed8f7d.JPG";